import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getView as getViewApi,
    getVendor as getVendorApi

} from "../../helpers/backend_helper";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; 


export const getView = createAsyncThunk("users/getView", async () => {
    try {
        const response = await getViewApi();
        return response.data
    } catch (error) {
        return error;
    }
});


export const getVendor = createAsyncThunk("users/getVendor", async () => {
    try {
        const response = await getVendorApi();
        return response.data
    } catch (error) {
        return error;
    }
});

